import { useCallback, useEffect } from "preact/hooks";
import useAxios from "../../hooks/useAxios";
import useAxiosCallback from "../../hooks/useAxiosCallback";


export default function useMembers() {

    const { isLoading, data, error, fetch: statefulRequest } = useAxios();

    const { isLoading: isPending, fetch: statelessRequest } = useAxiosCallback();

    const createMember = useCallback((config) => {
        const targetUrl = "/user/members";
        const requestParams = { method: "POST", ...config };
        return statelessRequest(targetUrl, requestParams);
    }, []);

    const updateMembers = useCallback((config) => {
        const targetUrl = "/user/members";
        const requestParams = { method: "PUT", ...config };
        return statelessRequest(targetUrl, requestParams);
    }, []);

    const deleteMembers = useCallback((config) => {
        const targetUrl = "/user/members";
        const requestParams = { method: "DELETE", ...config };
        return statelessRequest(targetUrl, requestParams);
    }, []);

    const getMembers = useCallback((config) => {
        const targetUrl = "/user/members";
        const requestParams = { method: "GET", ...config };
        return statefulRequest(targetUrl, requestParams);
    }, []);

    useEffect(() => getMembers("/user/members"), []);

    return { isLoading, isPending, data, error, getMembers, createMember, updateMembers, deleteMembers };
}